import en from "./messages/en.json";
import es from "./messages/es.json";
import fr from "./messages/fr.json";
import ptBr from "./messages/pt-br.json";

export const messages: Record<string, Record<string, string>> = {
  en: en as Record<string, string>,
  fr: fr as Record<string, string>,
  es: es as Record<string, string>,
  "pt-br": ptBr as Record<string, string>,
};

export const defaultLang = "fr";
export const supportedLangs = ["en", "fr", "es", "pt-br"];
